import { render } from "./FloatSettings.vue?vue&type=template&id=600bfe88&scoped=true"
import script from "./FloatSettings.vue?vue&type=script&lang=js"
export * from "./FloatSettings.vue?vue&type=script&lang=js"

import "./FloatSettings.vue?vue&type=style&index=0&id=600bfe88&scoped=true&lang=css"

import exportComponent from "/home/jocelino/IGAMES-PS2/panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-600bfe88"]])

export default __exports__